import React from 'react';
import { mui } from '@local/finsera-core/src/libs';

type LongTextDialogProps = {
  open: boolean;
  onClose: () => void;
  value: string;
  title?: string;
};

/**
 * Modal dialog for displaying very long text content
 *
 * @param open - Whether the dialog is open
 * @param onClose - Function to close the dialog
 * @param value - The value to display
 * @param title - The title of the dialog
 * @returns Rendered component
 */
const LongTextDialog = ({ open, onClose, value, title = 'Cell Content' }: LongTextDialogProps) => {
  return (
    <mui.core.Dialog open={open} onClose={onClose} maxWidth="md" fullWidth aria-labelledby="long-text-dialog-title">
      <mui.core.DialogTitle id="long-text-dialog-title">{title}</mui.core.DialogTitle>
      <mui.core.DialogContent dividers>
        <mui.core.Box
          sx={{
            maxHeight: '60vh',
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontSize: '14px',
            fontFamily: 'monospace',
            padding: '8px',
            backgroundColor: (theme) => theme.palette.background.paper,
          }}
        >
          {value}
        </mui.core.Box>
      </mui.core.DialogContent>
      <mui.core.DialogActions>
        <mui.core.Button onClick={onClose} color="primary">
          Close
        </mui.core.Button>
      </mui.core.DialogActions>
    </mui.core.Dialog>
  );
};

export default LongTextDialog;
